export default "__VITE_ASSET__f4e55fe0__"